// Numéros d'origine du site. Le script de suivi d'appels (public/js/suivi-appels.js) les remplace
// à l'affichage par un numéro de suivi : ne saisir ici que les numéros fournis pour CE site.
// Saisie : numéro national à 10 chiffres. Lien généré : tel:0033 + numéro sans le 0 (format attendu par le script).
// Le numéro administratif n'est jamais mis ici ni en lien tel:.

export const PHONE_CONFIG = {
  FR: {
    box: {
      LP: "0970252314", // NOMA FR BOX - LP + Call Ext : pages + extension d'appel Google Ads
      SB: "0970252315", // NOMA FR BOX - Sticky Bar : barre d'appel fixe
    },
  },
};

export const VERTICAL = "box";

const COUNTRY_PREFIX = { FR: "0033" };

function digits(type, vertical, country) {
  return PHONE_CONFIG[country][vertical][type].replace(/\D/g, "");
}

// Numéro affiché : "09 70 25 23 14"
export function getPhone(type = "LP", vertical = VERTICAL, country = "FR") {
  return digits(type, vertical, country).replace(/(\d{2})(?=\d)/g, "$1 ");
}

// Numéro du lien, sans "tel:" : "0033970252314"
export function getPhoneTel(type = "LP", vertical = VERTICAL, country = "FR") {
  return COUNTRY_PREFIX[country] + digits(type, vertical, country).replace(/^0/, "");
}

// Utilisé par les composants : { href, display }.
export const PHONES = {
  main: { href: "tel:" + getPhoneTel("LP"), display: getPhone("LP") },
  sticky: { href: "tel:" + getPhoneTel("SB"), display: getPhone("SB") },
};
